import { render } from "./AboutServiceSingle.vue?vue&type=template&id=4e3ddda0"
import script from "./AboutServiceSingle.vue?vue&type=script&lang=js"
export * from "./AboutServiceSingle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspaces\\Portfolio Folder\\pappalaity.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__